function WelcomeCtrl(VersionsService,
                     $state,
                     $rootScope,
                     DistributorsService,
                     SessionsService) {
  "ngInject";

  let vm = this;
  // 
  vm.paulsCurrentDistributorName = $rootScope.paulsCurrentDistributorName;
  vm.version_data = [];
  vm.loading = true;
  
  vm.proceedToSignIn = () => $state.go('sign_in');

  vm.capitalizeFirstLetter = string => string.charAt(0).toUpperCase() + string.slice(1);

  vm.giveOptionToChangeDistributor = function () {
    let userKey = SessionsService.getUserKey();
    if(userKey) {
      let distributorsPromise = DistributorsService.fetchAllByUser(userKey);
      return distributorsPromise.then(function (data) {
        vm.has_multiple_distributors = data.length > 1;
        return vm.loading = false;
      });
    }
  };

  vm.changeDistributor = () => $state.go('main.managing_org_selection');

  vm.getVersion = function () {
    let promise = VersionsService.getVersions();
    return promise.then(data => vm.version_data = data);
  };

  vm.initialize = function () {
    

    vm.identity = {
      key: SessionsService.getUserKey(),
      email: SessionsService.getUserEmail(),
      managingOrgId: SessionsService.getCurrentDistributorKey(),
      distributorName: SessionsService.getCurrentDistributorName()
    };

    vm.giveOptionToChangeDistributor();
    if (!vm.identity.email) {
      return $state.go("main.sign_in");

    } else {
      return vm.getVersion();
    }
  };
  return vm;
}
export {WelcomeCtrl}
